import { useDataTableRow } from '@foam/buoy/src/components/DataTable/DataTableBody';
import { PluginActionTypes } from '@foam/buoy/src/components/DataTable/plugins';
import React from 'react';
import { NoteBlock } from '~/components/NoteBlock';
import { ICreator } from '~/types';

type NoteProps = {
  actions: PluginActionTypes<ICreator>['expansionActions'];
};

export const Note: React.FC<NoteProps> = () => {
  const row = useDataTableRow<ICreator>();

  if (!row.original.notes) {
    return null;
  }

  return <NoteBlock note={row.original.notes} />;
};
